import React from 'react'

/**
 * The RERIGHT brand mark — bold R, a thin divider bar, then a red mirrored R,
 * with the RERIGHT wordmark. Mirrors components/ui/logo.tsx on reright.io.
 *
 * The left R + wordmark adapt to the background via `tone`:
 *   - 'auto' (default): text-gray-900 — reads dark on a light surface, and on
 *     the marketing pages the `.mkt` scope remaps that token so it reads light.
 *   - 'light': forced white — for dark surfaces WITHOUT the `.mkt` remap (e.g.
 *     the .rrauth auth pages), where text-gray-900 would stay black and vanish.
 *   - 'dark': forced near-black — for light surfaces.
 * The right mirrored R is always brand red.
 */
export default function Logo({ size = 'md', showText = true, tone = 'auto' }) {
  const dim = {
    sm: { r: 'text-[32px]', bar: 'h-[24px]', gap: 'gap-2',   word: 'text-[12px] tracking-[2px]' },
    md: { r: 'text-[44px]', bar: 'h-[34px]', gap: 'gap-2.5', word: 'text-[13px] tracking-[3px]' },
    lg: { r: 'text-[60px]', bar: 'h-[46px]', gap: 'gap-3',   word: 'text-[15px] tracking-[4px]' },
  }[size]

  const ink = tone === 'light' ? 'text-white' : 'text-gray-900'
  const barCls = tone === 'light' ? 'bg-white/45' : 'bg-gray-400'

  return (
    <div className={`flex items-center justify-center ${dim.gap}`}>
      <div className="flex items-center gap-2">
        <span className={`${dim.r} font-black leading-none ${ink}`} style={{ letterSpacing: '-2px' }}>R</span>
        <div className={`w-[2px] ${dim.bar} ${barCls}`} />
        <span
          className={`${dim.r} font-black leading-none text-[#DC2626] inline-block`}
          style={{ letterSpacing: '-2px', transform: 'scaleX(-1)' }}
        >
          R
        </span>
      </div>
      {showText && <span className={`${dim.word} font-bold uppercase ${ink}`}>RERIGHT</span>}
    </div>
  )
}
